import { useTranslation } from "react-i18next";
import { Popup } from "../Popup";
import { LegalContent } from "./LegalContent";
import type { LegalDocKey } from "../../constants/legal";

interface LegalModalProps {
  doc: LegalDocKey;
  visible: boolean;
  onClose: () => void;
}

export const LegalModal: React.FC<LegalModalProps> = ({
  doc,
  visible,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Popup visible={visible} onClose={onClose}>
      <div className="legal-modal-content">
        <p className="legal-modal-title foreground">{t(`legal.docs.${doc}`)}</p>
        <LegalContent doc={doc} />
      </div>
    </Popup>
  );
};
